import { Box, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

type Props = {
  company: string;
  partCount: number;
  isExpanded: boolean;
  onToggle: () => void;
};

export const PartGroupHeader = ({
  company,
  partCount,
  isExpanded,
  onToggle
}: Props) => {
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        '&:hover': {
          backgroundColor: 'action.hover'
        }
      }}
      onClick={onToggle}
    >
      <Typography variant="subtitle1" fontWeight={600}>
        {company} ({partCount})
      </Typography>
      <ExpandMoreIcon
        sx={{
          transform: isExpanded ? 'rotate(180deg)' : 'none',
          transition: 'transform 0.2s'
        }}
      />
    </Box>
  );
};
